import { SonarObjectReference } from '@types';
import { SyncState } from '@sonar-software/xuder';

export type SonarObjectsIdMapState = SyncState<Record<number, SonarObjectReference>>;

export const defaultSonarObjectsIdMapState: SonarObjectsIdMapState = { data: {} };
